var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
export default function setErrors(errorsVar) {
    /*
      Preferably this error type should have consistent properies like
      {
        message: string,
        status: int, //http status
        fatal: boolean,
        extention: any
      }
      but error handling responses vary a lot by lang, framework and etc so...
    */
    return function (error) {
        var _a;
        var currentErrors = (_a = errorsVar()) !== null && _a !== void 0 ? _a : [];
        if (error.message.includes('auth')) {
            error.name = 'Fatal';
        }
        errorsVar(__spreadArrays(currentErrors, [error]));
    };
}
